<template>
    <v-image :config="{image: this.image, ...configImage}" ref="imgRef" />
</template>

<script>
import Konva from 'konva'
import { get, min } from 'lodash'
import { getImageURL } from '@/helper/helper'
export default {
    name: "mockup-image",
    props: {
        layer: {
            type: Object,
            required: true
        },
        mockupID: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            file: null,
            image: null,
            imagedemo: null
        }
    },
    mounted(){
        // this.file = this.layer.file
    },
    created(){
        const image = new window.Image();
        image.src = getImageURL(this.layer.file.key, min([this.layer.width, 1000]), 'px', true);
        image.crossOrigin = "Anonymous";
        image.onload = () => {
            this.image = image;
        };
    },
    computed: {
       configImage() {
            var filters = []
            if (Array.isArray(this.layer._filters)) {
                filters = this.layer._filters.map(filter => get(Konva.Filters, filter))
            }
            return {
                ...this.layer,
                filters
            }
        } 
    },
}
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/BundledProduct/MockupBundled/MockupImage.vue